module.exports = __webpack_public_path__ + "img/Share_black.91b9516d.svg";